<script>
import { message } from 'ant-design-vue';
import { v4 as uuidv4 } from 'uuid';
import { PlusOutlined } from '@ant-design/icons-vue';
import youtube from '@/pages/helpCenter/previewHintHelpCenter/youtube-video-marketing-1.png';

export default {
  components: { PlusOutlined },
  data() {
    return {
      previewImage: '',
      previewVisible: false,
      imageList: [],
      youtube,
    };
  },
  props: {
    isMultiple: {
      type: Boolean,
      required: true,
    },
    initialImages: {
      type: Array,
    },
    isShowUploadList: {
      type: Boolean,
      default: true,
    },
    maxFiles: {
      type: Number,
      default: 8,
    },
  },
  mounted() {
    if (this.initialImages && this.initialImages.length > 0) {
      this.imageList = this.initialImages.map((item) => ({
        status: 'done',
        uid: uuidv4(),
        url: item.image || item.url || item,
        file: null,
        hintMediaId: item.hintMediaId || null, // Сохраняем id для отслеживания удалений
      }));
    }
  },
  methods: {
    getBase64(img, callback) {
      const reader = new FileReader();
      reader.onload = () => callback(reader.result);
      reader.readAsDataURL(img);
    },
    handleRemove(file) {
      this.imageList = this.imageList.filter((item) => item.uid !== file.uid);
      this.$emit('update:files', this.imageList);
    },
    handlePreview(file) {
      this.previewImage = file.url;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleChange(info) {
      this.getBase64(info.file, (base64Url) => {
        this.imageList = [...this.imageList, {
          status: 'done',
          uid: uuidv4(),
          url: base64Url,
          file: info.file,
        },
        ];
        this.$emit('update:files', this.imageList);
      });
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        message.error('You can only upload JPG or PNG file!');
      }
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        message.error('Image must be smaller than 20MB!');
      }
      return isJpgOrPng && isLt20M;
    },
  },
  watch: {
    initialImages: {
      handler(newValue, oldValue) {
        if (newValue === oldValue) {
          return;
        }
        if (newValue && oldValue
          && newValue.length === oldValue.length
          && newValue.every((item, index) => item === oldValue[index])) {
          return;
        }

        if (newValue && newValue.length > 0) {
          const alreadyProcessed = newValue.every((item) => item.status);
          if (alreadyProcessed) {
            this.imageList = newValue;
            return;
          }

          this.imageList = newValue.map((item) => {
            if (!item.status) {
              return {
                status: 'done',
                uid: uuidv4(),
                url: item.image || item.url || item,
                file: null,
                hintMediaId: item.hintMediaId || null,
              };
            }
            return item;
          });
        } else {
          this.imageList = [];
        }
      },
      immediate: true,
    },
  },
};
</script>

<template>
  <a-upload
    name="image"
    list-type="picture-card"
    :file-list="imageList"
    class="image-uploader"
    :show-upload-list="isShowUploadList"
    :before-upload="beforeUpload"
    :custom-request="handleChange"
    @remove="handleRemove"
    @preview="handlePreview"
    :multiple="isMultiple"
  >
    <div
      v-if="(isMultiple && this.imageList.length < this.maxFiles)
        || (!isMultiple && this.imageList.length < 1)"
    >
      <plus-outlined />
      <div class="ant-upload-text">Upload</div>
    </div>
  </a-upload>
  <a-modal :open="previewVisible" :footer="null" @cancel="handleCancel">
    <div v-if="previewImage[0] !== '<'">
      <img alt="example" style="width: 100%" :src="previewImage"/>
    </div>
    <div v-else>
      <img alt="example" style="width: 100%" :src="youtube"/>
      This is video from youtube. We can see this video in the preview mode.
    </div>
  </a-modal>
</template>

<style scoped lang="scss">
.image-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.img {
  width: 100px;
  height: 100px;
}
</style>
